/**
 * 会员信息
 */
import React from 'react';
import { Input, Row, Col, Icon, Tooltip, Button } from 'antd';
import PageLayout from '../../ui/PageLayout';
import MemberEdit from './MemberEdit';
import http from '../../../axios/http';
import messager from '../../ui/messager';
import OrgSelect from '../../ui/OrgSelect';
//会员选择信息
import MemberTeam from './MemberTeam';
//充值
import MemberRecharge from '../member/MemberRecharge';
//停车时长充值
import MemberDurationRecharge from '../member/MemberDurationRecharge';
//详情
import MemberDetail from '../member/MemberDetail';
import { global_data } from '../../ui/auth'

class MemberIndex extends React.Component {

    columns = [{
        title: '会员名称',
        dataIndex: 'name',
        width: '14%',
    }, {
        title: '证件号码',
        dataIndex: 'creditNo',
        width: '14%',
    }, {
        title: '地址',
        dataIndex: 'address',
        width: '20%',
    }, {
        title: '联系人',
        dataIndex: 'contactMan',
        width: '7%',
    }, {
        title: '联系电话',
        dataIndex: 'contactNumber',
        width: '10%',
    }, {
        title: '会员类型',
        dataIndex: 'status',
        width: '15%',
        render: (text, record, index) => {
            let t = "";
            t += record.tenant === 1 ? '租户' : '';
            if (record.agent === 1) {
                t += (t !== "" ? "/代办" : "代办");
            }
            if (record.mall === 1) {
                t += (t !== "" ? "/商城会员" : "商城会员");
            }
            if (record.auction === 1) {
                t += (t !== "" ? "/竞价会员" : "竞价会员");
            }
            return (
                <div>
                    <Tooltip title={t}>
                        <span>{t}</span>
                    </Tooltip>
                </div>
            )
        }
    }, {
        title: '状态',
        dataIndex: 'state',
        width: '6%',
        format: { 0: '正常', 1: '删除', 2: '停用' }
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '15%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("MEMBER_UPDATE")?
                <Tooltip title="修改">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("MEMBER_MEMBER")?
                <Tooltip title="会员下用户配置">
                    <Icon type="team" className="table-operate-icon" onClick={this.updateTeam.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("MEMBER_ENABLE")?
                <Tooltip title="启用">
                    <Icon type="check-circle" theme="filled" className="table-operate-icon" onClick={this.enable.bind(this, text)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("MEMBER_DISABLE")?
                <Tooltip title="停用">
                    <Icon type="stop" theme="filled" className="table-operate-icon" onClick={this.disable.bind(this, text)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("MEMBER_RECHARGE")?
                <Tooltip title="充值">
                    <Icon type="money-collect" theme="filled" className="table-operate-icon" onClick={this.doRecharge.bind(this, record)} />
                </Tooltip>
                :""}
                <Tooltip title="明细">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record)} />
                </Tooltip>
                {global_data.authCode.includes("MEMBER_DURATIONRECHARGE")?
                <Tooltip title="停车时长充值">
                    <Icon type="money-collect" theme="filled" className="table-operate-icon" onClick={this.doDurationRecharge.bind(this, record)} />
                </Tooltip>
                :""}
            </div>
        )
    }];

    state = {
        visible: false,
        editData: {},
        loadData: '',
        queryData: {},
        teamVisible: false,
        rechargeVisible: false,
        durationRechargeVisible:false,
        detailVisible: false,
        summary: {},
    };

    add = () => {
        this.setState({ editData: {}, visible: true });
    }

    update = (info, e) => {
        this.setState({ editData: info, visible: true });
    }

    enable = (info, e) => {
        http.post({
            url: "/member/enableMember",
            data: { id: info },
            success: (res) => {
                this.state.loadData(this.state.queryData);
                messager.notify("启用成功！");
            }
        });
    }

    disable = (info, e) => {
        http.post({
            url: "/member/disableMember",
            data: { id: info },
            success: (res) => {
                this.state.loadData(this.state.queryData);
                messager.notify("停用成功！");
            }
        });
    }

    //会员下的人员设置
    updateTeam = (info, e) => {
        this.refs["memberTeam"].initData(info.code,
            (res) => { this.setState({ editData: info, teamVisible: true }) }
        );
    }

    //充值
    doRecharge = (info, e) => {
        this.setState({ editData: info, rechargeVisible: true });
    }
    //停车时长充值
    doDurationRecharge = (info, e) => {
        this.setState({ editData: info, durationRechargeVisible: true });
    }

    //详情
    detail = (info, e) => {
        //查询当前账户的汇总信息
        http.post({
            url: '/agent/findAccountRecordSummary',
            data: { memberCode: info.code },
            success: (res) => {
                this.setState({ summary: res, editData: info, detailVisible: true });
                this.refs["detail"].loadTableData(info.code, "account");
                this.refs["detail"].loadTableData(info.code, "bond");
                this.refs["detail"].loadTableData(info.code, "duration");
            }
        });
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.name = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    //所属市场查询
    orgSelect = (value) => {
        let queryData = this.state.queryData;
        queryData["orgCode"] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="会员名称"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: 400 }}
                                />
                                <OrgSelect style={{ width: '200px', marginLeft: "10px" }}
                                    onChange={this.orgSelect}
                                    allowClear={true}
                                    orgType={4}
                                    treeDefaultExpandAll={true} />
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                {global_data.authCode.includes("MEMBER_ADD")?
                                    <Button type="primary" onClick={this.add}>新增</Button>
                                :""}
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/member/findMemberPage"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <MemberEdit
                    visible={this.state.visible}
                    onCancel={() => { this.setState({ visible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />

                <MemberTeam
                    visible={this.state.teamVisible}
                    onCancel={() => { this.setState({ teamVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    ref="memberTeam"
                    content="member"
                />
                <MemberRecharge
                    visible={this.state.rechargeVisible}
                    onCancel={() => { this.setState({ rechargeVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    content="agent"
                />
                <MemberDurationRecharge
                    visible={this.state.durationRechargeVisible}
                    onCancel={() => { this.setState({ durationRechargeVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    content="member"
                />
                <MemberDetail
                    visible={this.state.detailVisible}
                    onCancel={() => { this.setState({ detailVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    summary={this.state.summary}
                    ref="detail"
                    content="agent"
                />
            </div>
        )
    }
}

export default MemberIndex;